import { CdkMenuTrigger, Menu } from '@angular/cdk/menu';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { FcpButtonColors, FcpButtonVariants } from '../fcp-button';
import { FcpIconSVGColors, FcpIconSVGSizes, IconName } from '../fcp-icon-svg';

@Component({
    selector: 'fcp-menu',
    templateUrl: './fcp-menu.component.html',
    styleUrls: ['./fcp-menu.component.less'],
    standalone: false
})
export class FcpMenuComponent {
    @Input() public menuPosition: ConnectedPosition[];
    @Input() public variant: FcpButtonVariants;
    @Input() public color: FcpButtonColors;
    @Input() public disabled: boolean | 'disabled';
    @Input() public menuSize: 'medium' | 'large';
    @Input() public menuStyle: 'prominent' | 'subtle';
    @Input() public list: MenuListItem[];
    @Input() public iconOnly: boolean;

    @ViewChild(CdkMenuTrigger) public cdkMenuTrigger: CdkMenuTrigger;

    @Output() private menuClosed: EventEmitter<void>;
    @Output() private menuOpened: EventEmitter<void>;
    @Output() private menuItemTriggered: EventEmitter<MenuListItem>;

    constructor() {
        this.variant = FcpButtonVariants.Filled;
        this.color = FcpButtonColors.Default;
        this.disabled = false;
        this.menuSize = 'medium';
        this.menuStyle = 'prominent';
        this.menuClosed = new EventEmitter<void>();
        this.menuOpened = new EventEmitter<void>();
        this.menuItemTriggered = new EventEmitter<MenuListItem>();
        this.iconOnly = false;
    }

    public onCdkMenuClosed() {
        this.menuClosed.emit();
    }

    public onCdkMenuOpened() {
        this.menuOpened.emit();
    }

    public onMenuClicked(event: MouseEvent) {
        event.stopPropagation();
    }

    public close() {
        this.cdkMenuTrigger.close();
    }

    public open() {
        this.cdkMenuTrigger.open();
    }

    public toggle() {
        this.cdkMenuTrigger.toggle();
    }

    public isOpen(): boolean {
        return this.cdkMenuTrigger.isOpen();
    }

    public getMenu(): Menu | undefined {
        return this.cdkMenuTrigger.getMenu();
    }

    public registerChildMenu(child: Menu) {
        return this.cdkMenuTrigger.registerChildMenu(child);
    }

    public onMenuItemTriggered(item: MenuListItem, index: number) {
        if (typeof item?.triggerHandler === 'function') {
            item?.triggerHandler?.(item, index);
        }

        this.menuItemTriggered.emit(item);
    }
}

export interface MenuListItem {
    text: string;
    subtext?: string;
    value: string;
    disabled?: boolean;
    triggerHandler?: (item: MenuListItem, index: number) => void;
    icon?: MenuListItemIcon;
    separator?: boolean;
}

export interface MenuListItemIcon {
    name: IconName;
    color?: FcpIconSVGColors;
    size?: FcpIconSVGSizes;
    position?: 'left' | 'right';
}
